// extracted by mini-css-extract-plugin
module.exports = {"title":"title-MPzOb","sub":"sub-1Kq02","email":"email-schP7","button":"button-1NZjX"};